export default __webpack_public_path__ + "static/media/OlanRei_natpis-transp-01-header.33b70578.png";